import { getIcon } from '../helpers/utils';
import II18 from '../translate/II18';
import React from 'react';

export const DocumentRejectedMessage = () => {
  return (
    <div className={'document_rejected_message'}>
      {getIcon('material: block')}
      {II18.get('document_rejected_message')}
    </div>
  );
};
